import React from 'react';
import { connect } from 'react-redux';
//import Link from '../lib/Link'
//import LazyImage from '../lib/LazyImage'
//import {Bg} from '../field'
import {claim, find, release} from '../reducers/page'
import renderers from './ViewRenderer'

class PagedView extends React.Component {
	state = {
		page: 0,
		id: null
	}

	componentWillMount() {
		const {claim, view} = this.props

		claim(view.id)
		this.setState({id: view.id},
			() => this.update(0))
	}
	
	componentWillUnmount() {
		const {release, view} = this.props

		release(view.id)
	}
	componentWillReceiveProps({view}) {
		const {release, claim} = this.props
		if(this.props.view.id!==view.id) {
			release(this.props.view.id)
			claim(view.id)
			this.setState({id: view.id},
				() => this.update(0))
		}
	}
	first = () => {
		let page = 0
		this.setState({page})
		this.update(page)		
	}
	
	prev = () => {
		let page = this.state.page-1
		if (page<0) page = 0
		this.setState({page})
		this.update(page)		
	}
	
	next = () => {
		let page = this.state.page + 1
		this.setState({page})
		this.update(page)		
	}
	
	last = () => {
		const {viewData} = this.props
		
		if (!viewData) return
		let pages = Math.floor(viewData.total / viewData.options.pageSize)
		let q = viewData.total % viewData.options.pageSize
		if(q>0) pages += 1
		let page = pages-1
		this.setState({page})
		this.update(page)		
	}
	
	update = page => {
		const {id} = this.state
		const {find, view, lang} = this.props
		
		find(id, {
				collection: view.collection || 'node', 
				query: view.query,
				projection: view.projection,
				pageSize: view.pageSize,
				page,
				paginate: view.paginate,
				sort: view.sort,
				lang
			})
	}
	
	render() {
		const {view, viewData, lang} = this.props

		if (!viewData) return null
		let pages = Math.floor(viewData.total / viewData.options.pageSize)
		let q = viewData.total % viewData.options.pageSize
		if(q>0) pages += 1
		
		const RowRenderer = (view.rowRenderer&&renderers[view.rowRenderer])
			?renderers[view.rowRenderer]:
			renderers['row']
		
		return (
		<div className='view'>
			<div className='view-content'>
				{view.title && <h2 className='title'>{view.title}</h2>}
				{viewData.data.map((item, i) => 
					<RowRenderer key={i} index={i} entity={item} lang={lang}/>
				)}
			</div>
					
			<div className='view-pager'>
				{viewData.options.page > 0 && <a className='pager-button' onClick={this.first}><i className='fa fa-angle-double-left'></i></a>}
				{viewData.options.page > 0 && <a className='pager-button' onClick={this.prev}><i className='fa fa-angle-left'></i></a>}
				{viewData.options.page < pages-1 && <a className='pager-button' onClick={this.next}><i className='fa fa-angle-right'></i></a>}
				{viewData.options.page < pages-1 && <a className='pager-button' onClick={this.last}><i className='fa fa-angle-double-right'></i></a>}
			</div>
		</div>
		)
	}
}
function mapStateToProps(state, ownProps) {
	return {
		lang: state.page.lang,
		viewData: state.page[ownProps.view.id]
	}
}
export default connect(mapStateToProps, {claim, find, release})(PagedView);



// WEBPACK FOOTER //
// ./src/fm/block/PagedView.js